/**
 * The new sequence engine's own core enums.
 *
 * These deliberately duplicate the string values of `SequenceType` and
 * `SequenceEnabledStatus` in `libs/types/src/Sequences/Sequence.Interfaces.ts` (first
 * commit 2025-01-10 — the legacy sequences product). The values match so the persisted
 * columns are byte-identical; what changes is ownership. The new engine does not take its
 * core types from the old engine's module: that module carries the old model's semantics
 * with it, and it retires when the old engine does.
 *
 * Do not re-export the legacy enums from here, and do not import them into the new engine.
 */

/** The kinds of sequence the new engine implements. Persisted on enrollments and attempts. */
export enum BotSequenceType {
  PAST_DUE = "PAST_DUE",
  ABANDONED_CART = "ABANDONED_CART",
  MOVE_IN = "MOVE_IN",
  MOVE_OUT = "MOVE_OUT"
}

/** Operator-facing labels, one source for the page, the ticket titles and `{{Sequence:Type}}` (ENG-3216). */
export const BOT_SEQUENCE_TYPE_LABELS: Record<BotSequenceType, string> = {
  [BotSequenceType.PAST_DUE]: "Past Due",
  [BotSequenceType.ABANDONED_CART]: "Abandoned Cart",
  [BotSequenceType.MOVE_IN]: "Move In",
  [BotSequenceType.MOVE_OUT]: "Move Out"
};

/**
 * Whether a sequence type is live, dry-run, or off for a given scope.
 *
 * `SIMULATED` produces the full decision ledger without dispatching anything — the
 * scheduler books `simulated` attempts that are terminal at creation.
 */
export enum BotSequenceMode {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
  SIMULATED = "SIMULATED"
}
